import React, { useEffect, useState } from 'react';
import CommonModal from './CommonModal';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

const CHECKBOX_OPTIONS = [
  'Serve with Entree',
  'Serve with Mains',
  'Gluten Free',
  'Dairy Free',
  'Nut Free',
  'Celiac Option',
  'Sharing Plate',
  'Pack for Takeaway',
];

const CartCommentModal = ({ isOpen, cartId, onClose, onSuccess }) => {
  const [comment, setComment] = useState('');
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (!isOpen || !cartId) return;

    const fetchCartComment = async () => {
      try {
        const response = await callAPI(
          `${apiUrls.GET_CART_BY_ID}?cart_id=${cartId}`,
          {},
          'GET'
        );

        const comments = response?.data?.data?.comments;

        if (!comments) {
          setSelectedCheckboxes([]);
          setComment('');
          return;
        }

        const parts = comments.split('\n');
        setSelectedCheckboxes(
          parts[0]?.split(',').map(v => v.trim()) || []
        );
        setComment(parts[1]?.trim() || '');

      } catch (err) {
        console.error(err);
      }
    };

    fetchCartComment();
  }, [isOpen, cartId]);

  const toggleCheckbox = (value) => {
    setSelectedCheckboxes(prev =>
      prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    );
  };


  const handleAddComment = async () => {
    if (!cartId) return;

    const finalComment =
      `${selectedCheckboxes.join(', ')}\n ${comment || ''}`;

    const formData = new FormData();
    formData.append('id', cartId);
    formData.append('comment', finalComment);

    try {
      setLoading(true);

      await callAPI(
        apiUrls.CART_ADD_COMMENT,
        {},
        'POST',
        formData
      );

      onSuccess?.();
      onClose();

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="messageModal">
            <div class="modal-header">
                <h1 class="modal-title mdTitle" id="messageModalLabel">Add Comment </h1>
                <button type="button" class="btn-close" onClick={onClose}></button>
            </div>
          

            
            <div className="modal-body">
              <div className="modalBodyStyle">

                {CHECKBOX_OPTIONS.map((option, index) => (
                  <div className="mb-3 form-check" key={option}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`commentCheck${index + 1}`}
                      checked={selectedCheckboxes.includes(option)}
                      onChange={() => toggleCheckbox(option)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`commentCheck${index + 1}`}
                    >
                      {option}
                    </label>
                  </div>
                ))}

                <div className="mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Add your comment here..."
                    rows="3"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                </div>

              </div>
            </div>

            
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btnLight"
                onClick={onClose}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btnPrimary"
                onClick={handleAddComment}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Add Comment'}
              </button>
            </div>

       
    </CommonModal>
  );
};

export default CartCommentModal;
